/**
 * KSeF sanctions start date (BOO-3240 R3): 1 January 2027, defined in Poland's
 * timezone (+01:00 in winter). Lives outside the component file so Fast
 * Refresh can preserve component state (react-doctor only-export-components)
 * and so tests can assert the constant without importing the component tree.
 * A test asserts !isNaN — a silent Invalid Date would freeze the banner in
 * its pre-deadline state forever.
 */
export const SANCTIONS_START = Date.parse('2027-01-01T00:00:00+01:00');
